import Paper from '@material-ui/core/Paper'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableContainer from '@material-ui/core/TableContainer'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import classNames from 'classnames'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import consts from '../../../util/consts'
import Paginate from '../../components/Pagination'
import { fetchClientsRelatoryInit } from '../ClientsRelatoryActions'
import {
  StyledTableCellBody,
  StyledTableCellHeader,
} from '../../../components/hooks/BaseTableComponents'

function List(props) {
  const dispatch = useDispatch()
  const filters = useSelector(state => state.clients_relatory.filters)
  const [rowsPerPage, setRowsPerPage] = useState(consts.DEFAULT_PAGINATION)
  const { classes, items, totalSize, page } = props

  const onMovePage = (event, newPage) => {
    dispatch(fetchClientsRelatoryInit(newPage + 1, filters, rowsPerPage))
  }

  useEffect(() => {
    onMovePage()
  }, [rowsPerPage])

  const handleChangeRowsPerPage = event => {
    setRowsPerPage(event.target.value)
  }

  return (
    <>
      <TableContainer
        className={classNames({
          [classes.tableContainer]: true,
          [classes.tableStickHeader]: true,
        })}
      >
        <Table stickyHeader size="medium" className={classes.tableStyle}>
          <TableHead>
            <TableRow>
              <StyledTableCellHeader>Nome</StyledTableCellHeader>
              <StyledTableCellHeader>CPF/CNPJ</StyledTableCellHeader>
              <StyledTableCellHeader>Telefone</StyledTableCellHeader>
              <StyledTableCellHeader>Endereço</StyledTableCellHeader>
              <StyledTableCellHeader>
                Quantidade de Serviços
              </StyledTableCellHeader>
              <StyledTableCellHeader>
                Data do último Serviço
              </StyledTableCellHeader>
            </TableRow>
          </TableHead>
          <TableBody>
            {items.map(item => (
              <TableRow key={item.id}>
                <StyledTableCellBody>{item.name}</StyledTableCellBody>
                <StyledTableCellBody>
                  {item.cpf_cnpj || '-'}
                </StyledTableCellBody>
                <StyledTableCellBody>{item.phone}</StyledTableCellBody>
                <StyledTableCellBody>{item.address}</StyledTableCellBody>
                <StyledTableCellBody>{item.qty_service}</StyledTableCellBody>
                <StyledTableCellBody>
                  {item.last_date_service ? item.last_date_service : '-'}
                </StyledTableCellBody>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <Paginate
        handleChangeRowsPerPage={handleChangeRowsPerPage}
        rowsPerPage={rowsPerPage}
        rows={totalSize}
        page={page - 1}
        handleChangePage={onMovePage}
      />
    </>
  )
}

export default List
